 import firebase from 'firebase/app'
 import 'firebase/firestore'
 import 'firebase/auth'

 // Your web app's Firebase configuration
 var firebaseConfig = {
  apiKey: "AIzaSyB85btIshG77hvUQec3BIuZ8wlahqOBwjg",
  authDomain: "moneypanda-a2e2b.firebaseapp.com",
  databaseURL: "https://moneypanda-a2e2b.firebaseio.com",
  projectId: "moneypanda-a2e2b",
  storageBucket: "moneypanda-a2e2b.appspot.com",
  messagingSenderId: "57654933332",
  appId: "1:57654933332:web:836d0a11f75bed01b7bac1",
  measurementId: "G-GSL77D4QEW"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
 
  export default firebase